const APIMessageType = {
  SAVE: 'save',
  DELETE: 'delete',
}

export default APIMessageType
